var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPhoneIconGray(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 15,
    height: 16,
    viewBox: "0 0 15 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.1667 11.2797V13.2797C14.1675 13.4654 14.1294 13.6492 14.055 13.8193C13.9807 13.9894 13.8716 14.1421 13.7348 14.2676C13.5979 14.3932 13.4364 14.4887 13.2605 14.5482C13.0847 14.6077 12.8983 14.6298 12.7134 14.6131C10.6619 14.3902 8.69137 13.6892 6.96004 12.5664C5.34926 11.5428 3.98359 10.1772 2.96004 8.56641C1.83336 6.82721 1.1322 4.84707 0.91337 2.78641C0.89671 2.60205 0.91862 2.41625 0.977704 2.24082C1.03679 2.0654 1.13175 1.9042 1.25655 1.76749C1.38134 1.63077 1.53324 1.52155 1.70256 1.44675C1.87189 1.37196 2.05493 1.33325 2.24004 1.33307H4.24004C4.56357 1.32989 4.87723 1.44446 5.12254 1.65543C5.36786 1.8664 5.52809 2.15937 5.57337 2.47974C5.65779 3.11978 5.81434 3.74822 6.04004 4.35307C6.12973 4.59169 6.14915 4.85102 6.09597 5.10033C6.0428 5.34964 5.91928 5.57848 5.74004 5.75974L4.89337 6.60641C5.84241 8.27544 7.22434 9.65737 8.89337 10.6064L9.74004 9.75974C9.9213 9.5805 10.1501 9.45697 10.3994 9.4038C10.6488 9.35063 10.9081 9.37004 11.1467 9.45974C11.7516 9.68544 12.38 9.84199 13.02 9.92641C13.3439 9.97209 13.6396 10.1352 13.8511 10.3847C14.0625 10.6343 14.1748 10.9528 14.1667 11.2797Z",
    stroke: "#535762",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhoneIconGray);
export default __webpack_public_path__ + "static/media/phone-icon-gray.ca6e6270ba258507954b6715f9a699db.svg";
export { ForwardRef as ReactComponent };